// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerWrapper {
    z-index: 10;
    border-top: 5px solid var(--psyellow);
    display: flex;
    padding-top: 0cm;
    margin: 0 1.6cm;
}
.pageIndex {
    width: 10%;
    padding-top: 0.8cm;
    display: flex;
    justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/valuation/footer/footer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,qCAAqC;IACrC,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".footerWrapper {\n    z-index: 10;\n    border-top: 5px solid var(--psyellow);\n    display: flex;\n    padding-top: 0cm;\n    margin: 0 1.6cm;\n}\n.pageIndex {\n    width: 10%;\n    padding-top: 0.8cm;\n    display: flex;\n    justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
